import { render, staticRenderFns } from "./ButtonSizePaginationNav.vue?vue&type=template&id=16aae4de"
import script from "./ButtonSizePaginationNav.vue?vue&type=script&lang=js"
export * from "./ButtonSizePaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports